<<template>
  <v-container>
    <h1>{{ $t("Video Player") }} </h1>
    <div>
      <v-select 
        outlined
        :items="video_files" 
        id="videoFile" 
        item-text="name" 
        item-value="name" 
        :label="$t('Select Video File')"
        v-model="filename"
        @change="getVideoFileName">
        <template v-slot:item="{ item }">
          <span>{{item.from}} -> {{item.to}} file: {{ item.name }}</span>
        </template>
        <template v-slot:selection="{ item }">
          <span>{{item.from}} -> {{item.to}} file: {{ item.name }}</span>
        </template>
      </v-select>
    </div>
    <p>{{ $t("Playing video") }}: {{ filename }}</p>
   <video
      v-show="videoSrc"  
      :key="videoSrc"
      ref="videoPlayer"
      class="video-player"
      controls
   >
      <source :src="videoSrc" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </v-container>
</template>

<script>
export default {
  name: 'VideoPlayer',
  data() {
    return {
      videoSrc: '',
      filename: '', // This should be set to the default video file name if needed
      video_files: [],
    };
  },
  methods: {
    async getVideoFileName() {
      try {
        let data = await this.$http.get(`/videofiles/signed/${this.filename}`)
        console.log('Video filename data:', data);
        if (data && data.data && data.data.signed_url) {
          this.videoSrc = "https://restapi.fuelomat.cz/api/v2" + data.data.signed_url;
        } else {
          console.error('Filename not found in response');
        }
      } catch (error) {
          console.error('Error fetching video filename:', error);
      }
    },

    async getVideoFileSelection() {
      try {
        const data = await this.$http.get(`/videofiles`);
        console.log('Video files:', data)
        console.log('Video files:', data.data)
        this.video_files = data.data || [];
      } catch (error) {
          console.error('Error fetching selected video:', error);
      }
    }
  },
  mounted() {
    this.getVideoFileSelection();
  },
};
</script>
 

